<app-section-grid *ngIf="!embeddedMode" [subSection]="'Create Social Profile'"></app-section-grid>

<app-stepper-grid *ngIf="!embeddedMode"></app-stepper-grid>

<div 
  class="relative w-full max-w-4xl mx-auto p-10 bg-white rounded-3xl mb-5"
  [class.border]="hasBorder"
  [class.border-gray-200]="hasBorder">
    <form [formGroup]="siteForm" (ngSubmit)="onSubmit()">
        <!-- Header -->
        <div class="text-center mb-10">
            <h1 class="text-3xl font-bold text-gray-800 tracking-tight"> Social Profile Details </h1>
            <p class="mt-2 text-gray-400"> Enter the social profile details below.</p>
        </div>

        <!-- Centered fields block -->
        <div class="w-full max-w-2xl mx-auto">
            <div class="grid grid-cols-12 gap-6">
                <!-- Domain -->
                <div class="mb-2 col-span-12 lg:col-span-12">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🌐 Domain <small class="text-gray-400">(optional)</small>
                    </label>

                    <textarea formControlName="Domain" rows="1" placeholder="Enter domain..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                    focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>

                <!-- Site URL -->
                <div class="mb-2 col-span-12 lg:col-span-12">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🔗 Social Page/Site <small class="text-gray-400">(optional)</small>
                    </label>

                    <textarea formControlName="siteUrl" rows="1" placeholder="Enter URL..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                    focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>

                <div class="mb-2 col-span-12 lg:col-span-12">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🧱 Cms Type <small class="text-gray-400">(optional)</small>
                    </label>
                    <textarea formControlName="cmsType" rows="1" placeholder="Enter CMS type..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                    focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>

                    <div *ngIf="siteForm.get('cmsType')?.touched && siteForm.get('cmsType')?.invalid"
                        class="mt-1 text-xs text-red-500">
                    </div>
                </div>

                <!-- Full Logo -->
                <div class="mb-2 col-span-12 lg:col-span-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🖼 Primary Logo <small class="text-red-300">(required)</small>
                    </label>

                    <div class="relative">
                        <input type="file" accept="image/png" (change)="onFileChange($event, 'full')"
                            class="absolute inset-0 opacity-0 cursor-pointer z-10" />

                        <div class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                text-gray-400 text-sm shadow-sm">
                            {{ fullLogoFile?.name || 'Choose file' }}
                        </div>
                    </div>

                    <div *ngIf="fullLogoError" class="mt-1 text-xs text-red-500">
                        {{ fullLogoError }}
                    </div>
                    <div *ngIf="fullLogoPreview" class="mt-3 flex justify-start">
                        <div
                            class="bg-white border border-gray-200 rounded-xl p-4 shadow-sm inline-flex items-center justify-center min-w-[200px] h-24">
                            <img [src]="fullLogoPreview" class="max-h-full max-w-full object-contain"
                                alt="Primary logo preview" />
                        </div>
                    </div>
                </div>


                <!-- Thumbnail -->
                <div class="mb-2 col-span-12 lg:col-span-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🧩 Thumbnail Image <small class="text-red-300">(required)</small>
                    </label>

                    <div class="relative">
                        <input type="file" accept="image/png" (change)="onFileChange($event, 'thumb')"
                            class="absolute inset-0 opacity-0 cursor-pointer z-10" />

                        <div class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                text-gray-400 text-sm shadow-sm">
                            {{ thumbFile?.name || 'Choose file' }}
                        </div>
                    </div>

                    <div *ngIf="thumbError" class="mt-1 text-xs text-red-500">
                        {{ thumbError }}
                    </div>

                    <img *ngIf="thumbPreview" [src]="thumbPreview"
                        class="mt-3 w-full max-h-[75px] max-w-[75px] object-cover rounded-xl border border-gray-200 shadow-sm"
                        alt="Thumbnail preview" />
                </div>


            </div>
        </div>

        <app-submit-grid></app-submit-grid>

    </form>
</div>

<app-footer-grid *ngIf="!embeddedMode"></app-footer-grid>
